import {React, useState,useEffect} from 'react';
import {Placeholder} from 'react-bootstrap';

import Api from '../component/api';
import Breadcrumb from "../component/Breadcrumb";
import Sorting from "../component/Sorting";
import ProductsList from "../component/ProductsList";
import ProductPagination from "../component/ProductPagination";

function CategoryPage({ categoryId }) {
    //const [data, setData] = useState([]);
    const [data, setData] = useState({
        name: "", // مقدار پیش‌فرض
        description: "", // مقدار پیش‌فرض
        meta_title: "", // مقدار پیش‌فرض
        meta_description: "", // مقدار پیش‌فرض
        meta_keywords: "", // مقدار پیش‌فرض
        active: "0", // مقدار پیش‌فرض
        images: {}, // مقدار پیش‌فرض: آبجکت خالی
        label: "", // مقدار پیش‌فرض
        products: [], // مقدار پیش‌فرض: آرایه خالی
        sort_orders: [], // مقدار پیش‌فرض: آرایه خالی
        sort_selected: false, // مقدار پیش‌فرض: بولین
        pagination: {}, // مقدار پیش‌فرض: آبجکت خالی
        facets: [], // مقدار پیش‌فرض: آرایه خالی
        breadcrumbs: { links: [] }, // مقدار پیش‌فرض: آبجکت شامل آرایه خال
        categories:{},
        categoryAccess:true
    });
    const [loading, setLoading] = useState(false); 
    const [error, setError] = useState([]);
    const [currentSort, setCurrentSort] = useState('');

    async function fetchData(categoryId,nextPage=0,order='') {

        if(!categoryId)
        {
            return;
        }
        setLoading(true);
        try {
            const response = await Api("categoryproducts",{id_category: categoryId,page: nextPage,order: order,with_category_tree: true});
            if(response.success==true){
                if(nextPage==0){
                    setData(response.psdata);
                }else{
                    setData((prevData) => ({
                        ...prevData, // نگه داشتن داده‌های فعلی
                        ...response.psdata, // به‌روزرسانی تمامی داده‌ها با پاسخ جدید
                        products: [...prevData.products, ...response.psdata.products], // ترکیب محصولات قبلی و جدید
                    }));
                }
                //setData(response.psdata);
            }
        } catch (error) {
            console.error("API Error:", error);
        } 
        finally {
            setLoading(false); // پایان بارگذاری
        }
    }
    useEffect(() => {
        fetchData(categoryId);
    }, [categoryId]);

    useEffect(() => {
        
        if (data.name !=null && data.categoryAccess === false) {
        
            const backName = data.name || ''; // اگر name هنوز null بود، خالی می‌کنیم
            const redirectUrl = `${global.config.domain_url}/login?back=${categoryId}-${backName}`;
            window.location.href = redirectUrl;
        }
    }, [data, categoryId]);
    
    let breadcrumbs = data.breadcrumbs.links.filter((breadcrumb) => breadcrumb.id != 0).map((breadcrumb) => {
            
        return {
          link: breadcrumb.url.replace(global.config.domain_url, ""), // مقدار لینک
          name: breadcrumb.title, // مقدار نام
        };
    });

    return(
        <div>
            <div className="container">
            {loading?
                (
                    <>
                        <nav className='breadcrumb-section' aria-label="breadcrumb-1">
                            <Placeholder className="breadcrumb" animation="glow">
                                <Placeholder xs={2} />
                            </Placeholder>
                        </nav>
                        <Placeholder as="h1" animation="glow">
                            <Placeholder xs={2} size="lg" />
                        </Placeholder>
                    </>
                ):       
                (
                    <>
                        <Breadcrumb path={breadcrumbs}/>
                        <h1>{data.name}</h1>
                        <div className='d-flex gap-3 flex-wrap mb-5 justify-content-center'> 
                            {data.categories?.children?.length > 0 && 
                                data.categories.children
                                    .map((category) => (
                                      
                                            <a key={category.id} href={category.link} title={category.name} className='category category-box d-flex flex-column align-items-center rounded-3 justify-content-center link-underline-light card-title' >
                                                {/*<img src={category.image_link.url} alt={category.name} />*/}
                                                {category.name}
                                            </a>
                                       
                                    ))
                            }
                        </div>
                    </>
                )
            }
            {data.products.length === 0 && loading === false ? (
                <div> 
                    {data.categoryAccess==false && data.name !== null ? (
                        <a 
                          href={`${global.config.domain_url}/login?back=${categoryId}-${data.name}`}
                        >
                            جهت مشاهده محصولات این دسته بندی روی این لینک کلیک کنید
                        </a>
                    ):(<></>)}
                {/*    محصولی در این شاخه نیست*/}
                </div>
            ) :(
            <> 
           
            <Sorting 
                sortOrder={data.sort_orders}
                fetchData = {fetchData} 
                categoryId = {categoryId} 
                onSortChange={setCurrentSort}
                currentSort={currentSort}
            />
            <ProductsList  
                Products = {data.products} 
                loading = {loading}
            />
            <ProductPagination 
                pagination = {data.pagination}  
                fetchData = {fetchData} 
                categoryId = {categoryId} 
                loading = {loading}
                currentSort={currentSort}
            />
            </>)}
            </div>
        </div>
    );
};

export default CategoryPage;